import { render, staticRenderFns } from "./sub-task.vue?vue&type=template&id=0c1f91cd&"
import script from "./sub-task.vue?vue&type=script&lang=js&"
export * from "./sub-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c1f91cd')) {
      api.createRecord('0c1f91cd', component.options)
    } else {
      api.reload('0c1f91cd', component.options)
    }
    module.hot.accept("./sub-task.vue?vue&type=template&id=0c1f91cd&", function () {
      api.rerender('0c1f91cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/sub-task.vue"
export default component.exports